// src/domains/auth/utils/ssoTransfer.ts

import Cookies from 'js-cookie';

export const handleSSOTransfer = () => {
  const { location } = window;

  // Check if the session cookie exists
  const accessToken = Cookies.get('accessToken');

  if (accessToken) {
    // If the cookie exists, the user is logged in. Redirect to the return path.
    const urlParams = new URLSearchParams(location.search);
    const returnToPath = urlParams.get('returnTo');

    // Check if already on the return path to avoid a loop
    if (location.pathname !== returnToPath) {
      window.location.href = returnToPath || '/';
    }
  } else {
    // If the cookie does not exist, redirect to login
    window.location.href = '/login';
  }
};
